import React from 'react';
import { Grid } from '@material-ui/core';
import { Magnetic as Mi } from '../../styles';
import { getProgressBarColor, getProgressBarHeight, getProgressBarThresholdFontSize, getProgressBarThresholdMarginRight, getProgressBarThresholdMarginTop, getThredsholdIndicatorColor, getThresholdIndicatorMarginLeft, getValidProgress } from './services';
import { StyledProgressBar, StyledProgressDiv, StyledProgressPercentage, StyledThresholdIndicatorDiv } from './styles';
/**
 * Props for ProgressBar component
 * @param {string} idPrefix css id prefix
 * @param {ProgressBarColor} color progressbar color
 * @param {ProgressBarHeight} height progressbar height
 * @param {number} progress progress percentage to show inside progressbar
 * @param {boolean} isProgressPercentageDisplayed if true progress percentage will be displayed inside progressbar
 * @param {string} progressPercentageColor progress percentage value display color
 * @param {number | null} thresholdIndicator arrow indication will appear if value provided
 * @param {ProgressBarThresholdIndicatorColor} thresholdIndicatorColor threshold indicator color
 * @param {boolean} shouldShowActualPercentage if true actual percentage will be display inside progressbar even value is greater than 100 else max is 100 if value is greater than 100
 */
export const ProgressBar = ({ idPrefix = 'progress-bar', color, height, progress, thresholdIndicator, thresholdIndicatorColor, isProgressPercentageDisplayed = false, progressPercentageColor = Mi.colorWhite, shouldShowActualPercentage = false }) => {
    const progressPercentage = isProgressPercentageDisplayed ? (React.createElement(StyledProgressPercentage, { id: `${idPrefix}__progress-percentage`, progressPercentageColor: progressPercentageColor },
        shouldShowActualPercentage ? progress : getValidProgress(progress),
        "%")) : null;
    return (React.createElement(StyledProgressBar, { id: idPrefix, style: {
            minHeight: `${getProgressBarHeight(height, isProgressPercentageDisplayed)}px`
        } },
        React.createElement(StyledProgressDiv, { id: `${idPrefix}__loading-progress`, style: {
                backgroundColor: getProgressBarColor(color),
                width: `${getValidProgress(progress)}%`,
                minHeight: `${getProgressBarHeight(height, isProgressPercentageDisplayed)}px`
            } }, progressPercentage),
        thresholdIndicator !== null && thresholdIndicator !== undefined && (React.createElement(Grid, { container: true, direction: "row", wrap: "nowrap", id: `${idPrefix}__progress-threshold` },
            React.createElement("div", { style: { width: `${thresholdIndicator}%` } }),
            React.createElement("div", { style: {
                    fontSize: `${getProgressBarThresholdFontSize(height, isProgressPercentageDisplayed)}px`,
                    marginTop: `${getProgressBarThresholdMarginTop(height, isProgressPercentageDisplayed)}px`,
                    marginRight: getProgressBarThresholdMarginRight(thresholdIndicator)
                } },
                isProgressPercentageDisplayed && (React.createElement("div", { id: `${idPrefix}__progress-threshold-percentage`, style: {
                        marginLeft: thresholdIndicator < 10 ? `-${Mi.spacer08}` : `-${Mi.spacer12}`
                    } },
                    thresholdIndicator,
                    "%")),
                React.createElement(StyledThresholdIndicatorDiv, { className: "mi-icon-arrow-down", style: {
                        color: getThredsholdIndicatorColor(thresholdIndicatorColor),
                        marginLeft: getThresholdIndicatorMarginLeft(height, isProgressPercentageDisplayed, thresholdIndicator)
                    } }))))));
};
//# sourceMappingURL=ProgressBar.js.map